import React from "react";
import { Button } from "@mui/material";
import { APIErrorFaceBoxWrapper } from "./APIErrorFaceBox.styles.ts";

interface APIErrorFaceBoxProps {
	buttonClick: () => void;
	buttonText: string;
	headerText: string;
	descriptionText: string;
	errorCode?: string | null | number;
	faceBoxType?: "generic" | "notFound";
}

export const APIErrorFaceBox = ({
	buttonClick,
	buttonText,
	headerText,
	descriptionText,
	errorCode,
	faceBoxType = "generic"
}: APIErrorFaceBoxProps) => {
	return (
		<APIErrorFaceBoxWrapper>
			<div>
				<img
					src={faceBoxType === "generic" ? "/assets/UserAuthServiceError.svg" : "/assets/NotFound.svg"}
					alt="sad box logo"
					data-testid="sad-box-logo"
				/>
				{errorCode && <span>(Error Code: {errorCode})</span>}
			</div>
			<div>
				<h1 data-testid="api-error-box-header">{headerText}</h1>
				<p data-testid="api-error-box-description">{descriptionText}</p>
			</div>
			<Button
				variant="contained"
				onClick={buttonClick}
				data-testid="api-error-box-button"
			>
				{buttonText}
			</Button>
		</APIErrorFaceBoxWrapper>
	);
};
